import Cookies from 'universal-cookie';
import ConsoleLogger from "./ConsoleLogger";
const context = "CookiesHandler";
var CookiesHandler = (function () {
    const cookies = new Cookies();

    // var previous_booking_id_key = "previous_booking_id";
    // var instance_key = "instance";
    // var app_name_key = "app_name";
    // var app_user_name_key = "app_user_name";
    // var app_mobile_number_key = "app_mobile_number";
    // var app_email_key = "app_email";
    // var session_key = "session";
    // var refresh_token_key = "refresh_token";


    // var setInstance = function (instance_value) {
    //     cookies.set("instance", instance_value, { path: '/' });
    //     //console.log("!!!!!!!!!!!!!!!!!!!!! SET API TOKEN "+instance_key+"==> "+instance_value);
    // }

    // var setSessionId = function (session_value) {
    //     cookies.set("session", session_value, { path: '/' });
    //     //console.log("!!!!!!!!!!!!!!!!!!!!! SET ACCESS TOKEN "+session_key+"==> "+session_value);
    // }

    // var setRefreshToken = function (refresh_token_value) {
    //     cookies.set("refresh_token", refresh_token_value, { path: '/' });
    //     //console.log("!!!!!!!!!!!!!!!!!!!!! SET REFRESH TOKEN "+refresh_token_key+"==> "+refresh_token_value);
    // }

    // var setUserId = function (user_id_value) {
    //     cookies.set("id", user_id_value, { path: '/' });
    //     //console.log("!!!!!!!!!!!!!!!!!!!!! SET REFRESH TOKEN "+refresh_token_key+"==> "+refresh_token_value);
    // }

    // var setIssuedAt = function (issued_at_value) {
    //     cookies.set("issued_at", issued_at_value, { path: '/' });
    //     //console.log("!!!!!!!!!!!!!!!!!!!!! SET REFRESH TOKEN "+refresh_token_key+"==> "+refresh_token_value);
    // }




    // var getInstance = function () {
    //     var instance = cookies.get("instance");
    //     return instance;
    // }

    // var getSessionId = function () {
    //     var session = cookies.get("session");
    //     return session;
    // }

    // var getRefreshToken = function () {
    //     var refresh_token = cookies.get("refresh_token");
    //     return refresh_token;
    // }

    // var getUserId = function(){
    //     var user_id = cookies.get("id");
    //     return user_id;
    // }


    // var getIssuedAt = function(){
    //     var issued_at = cookies.get("issued_at");
    //     return issued_at;
    // }


    // var logout = function(){
    //     var isLogout = this.removeAllCookies();
    //     return isLogout;
    // }





    // var removeAllCookies = function () {

    //     try {
    //         cookies.remove("instance", { path: '/' });
    //         cookies.remove("session" , {path : '/'});
    //         cookies.remove("refresh_token" , {path : '/'});
    //         cookies.remove("id" , {path : '/'});
    //         cookies.remove("issued_at" , {path : '/'});

    //         return true;
    //     } catch (e) {
    //         ConsoleLogger.log(context,"Error In Removing All Cookies : " + e);

    //         return false;
    //     }


    // }


    var setCurrentPageId = function (page_id) {
        cookies.set("current_page_id", page_id, { path: '/' });
        //console.log("!!!!!!!!!!!!!!!!!!!!! SET REFRESH TOKEN "+refresh_token_key+"==> "+refresh_token_value);
    }
    var getCurrentpageId = function () {
        var page_id = cookies.get("current_page_id");
        return page_id;
    }

    var setCurrentPageName = function (page_name) {
        cookies.set("current_page_name", page_name, { path: '/' });
        //console.log("!!!!!!!!!!!!!!!!!!!!! SET REFRESH TOKEN "+refresh_token_key+"==> "+refresh_token_value);
    }
    var getCurrentpageName = function () {
        var page_name = cookies.get("current_page_name");
        return page_name;
    }
    var setUserAuthState = function (userAuthState) {
        cookies.set("userAuthState", userAuthState, { path: '/' });
    }
    var getUserAuthState = function () {
        var userAuthState = cookies.get("userAuthState");
        return userAuthState;
    }




    return {
        setCurrentPageId: setCurrentPageId,
        getCurrentpageId: getCurrentpageId,
        setCurrentPageName: setCurrentPageName,
        getCurrentpageName: getCurrentpageName,
        setUserAuthState,
        getUserAuthState
    }

})();

export default CookiesHandler;


// WEBPACK FOOTER //
// ./src/Utils/CookiesHandler.js